module.exports = __webpack_public_path__ + "static/media/ZP.a568062d.pdf";